import {
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    TextField,
    Typography,
} from '@mui/material';
import { LocationDescriptor } from 'history';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { If } from 'app/components/if';
import { AuthContext } from 'app/model/auth-context';
import { RootState } from 'app/store';

import { handleLogin, selectLoggedIn } from './auth.slice';

interface LoginProps extends RouteComponentProps {
    returnUrl?: LocationDescriptor;
    loggedIn: boolean;

    handleLogin: (username: string, password: string) => Observable<AuthContext>;
}

interface LoginState {
    username: string;
    password: string;
    duoModal: boolean;
}

class Login extends React.Component<LoginProps, LoginState> {
    public constructor(props: LoginProps | Readonly<LoginProps>) {
        super(props);

        this.state = {
            username: '',
            password: '',
            duoModal: false,
        };
    }

    public render() {
        return (
            <Container maxWidth='sm'>
                <If condition={this.props.loggedIn}>
                    <Redirect to='/' />
                </If>
                <Dialog
                    open={this.state.duoModal}
                    onClose={() => this.setState({ duoModal: false })}
                    aria-labelledby='duo-dialog-title'
                    aria-describedby='duo-dialog-description'
                >
                    <DialogTitle id='duo-dialog-title'>DUO Login</DialogTitle>
                    <DialogContent>
                        <DialogContentText id='duo-dialog-description'>
                            Please approve the login in your DUO app.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ duoModal: false })} autoFocus>
                            Dismiss
                        </Button>
                    </DialogActions>
                </Dialog>
                <form
                    onSubmit={(evt) => {
                        evt.preventDefault();
                        if (-1 !== this.state.username.indexOf('@')) {
                            this.setState({ duoModal: true });
                        }
                        this.props
                            .handleLogin(this.state.username, this.state.password)
                            .pipe(finalize(() => this.setState({ duoModal: false })))
                            .subscribe(() => {
                                if (this.props.returnUrl) {
                                    this.props.history.push(this.props.returnUrl);

                                    return;
                                }
                                this.props.history.push('/');
                            });
                    }}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Typography variant='body1'>
                                Enter your AFS username and password to login. The username should be in full domain
                                format, for example: <strong>jsmith@affinitysolutions.com</strong>
                            </Typography>
                            <Typography variant='body1'>
                                Upon submitting the form, you will promptly receive a<strong> DUO 2FA</strong>{' '}
                                notification on your device, so have it handy to approve the login.
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                id='username'
                                label='Username'
                                onChange={(evt) => this.setState({ ...this.state, username: evt.target.value })}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                id='password'
                                label='Password'
                                type='password'
                                onChange={(evt) => this.setState({ ...this.state, password: evt.target.value })}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button type='submit' variant='contained' color='primary'>
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Container>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    loggedIn: selectLoggedIn(state),
});

const connected = connect(mapStateToProps, { handleLogin })(withRouter(Login));

export { connected as Login };
